import { tokens as $ } from '@sail/tokens';
import { useUiConfig } from '../providers/UiConfigProvider';
import { usePartialIframe } from './OverlayOverrides';
import { css } from '../css';
export const useTooltipIframe = (props)=>{
    const uiConfig = useUiConfig();
    const getUILayers = uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig._unstable_getUILayers;
    const { triggerRef, ...remainingProps } = props;
    const containerStylesTypeDescription = css({
        padding: 'medium',
        maxWidth: '300px',
        backgroundColor: 'surface',
        textColor: 'text'
    });
    const containerStylesTypeLabel = css({
        paddingX: 'small',
        paddingY: 'xsmall',
        maxWidth: '200px',
        textColor: $['color.neutral.0'],
        backgroundColor: $['color.neutral.700']
    });
    const containerStyles = [
        css({
            font: 'body.small'
        }),
        props.type === 'label' ? containerStylesTypeLabel : containerStylesTypeDescription
    ];
    return usePartialIframe({
        ...remainingProps,
        offset: 4,
        targetRef: triggerRef,
        containerStyles,
        uiLayers: getUILayers ? getUILayers() : []
    });
};

//# sourceMappingURL=TooltipOverrides.js.map